import { useContext } from 'react';
import FormValidatorContext from '../FormValidatorContext';

const EMPTY_MSG = 'Required';

export default function useFieldRequiredStatus(namePath: string[]) {
  const { errorFields, enableRequired } = useContext(FormValidatorContext);
  const errorField = errorFields[namePath.join('.')];
  return {
    status: errorField === EMPTY_MSG ? 'error' : undefined,
    enableRequired,
  } as const;
}
